<div class="container-fluid in-town ion-no-padding" *ngIf="loaded">
  <div class="row">
    <div class="col ion-padding ion-text-center">
      <ul>
        <li *ngIf="!hidegigs" class="ion-float-left ion-padding">
          <h3 (click)="show('gigs')" [ngClass]="{'active': showgigs}" href="#gigs" data-slider="gigs">Gigs</h3>
        </li>
        <li *ngIf="!hidejobs" class="ion-float-left ion-padding">
          <h3 (click)="show('jobs')" [ngClass]="{'active': showjobs}" href="#jobs" data-slider="jobs">Jobs</h3>
        </li>
        <li *ngIf="!hidevols" class="ion-float-left ion-padding">
          <h3 (click)="show('vols')" [ngClass]="{'active': showvols}" href="#volunteers" data-slider="volunteers">Volunteers</h3>
        </li>
        <li *ngIf="!hideads" class="ion-float-left ion-padding">
          <h3 (click)="show('ads')" [ngClass]="{'active': showads}" href="#promote" data-slider="promote">Promote</h3>
        </li>
      </ul>
    </div>
  </div>
  <div class="row gigs" id="gigs" *ngIf="showgigs">
    <div class="col ion-no-padding slide-scroll">
      <div class="slide-wrapper">
        <div *ngIf="placeholder" class="slide ion-text-left">
          <ge-card service="gigs" skill="{{skill}}" [code]="country.code" [country]="country.name" [placeholder]="true" href="/sign-up"></ge-card>
        </div>
        <div *ngFor="let gig of gigsintown | async;" class="slide ion-text-left">
          <gig-card [id]="gig.id" [image]="false" [highlights]="false" href="/gigs/detail/{{gig.slug}}"></gig-card>
        </div>
      </div>
    </div>
  </div>
  <div class="row jobs" id="jobs" *ngIf="showjobs">
    <div class="col ion-no-padding slide-scroll">
      <div class="slide-wrapper">
        <div *ngIf="placeholder" class="slide ion-text-left">
          <ge-card service="jobs" skill="{{skill}}" [code]="country.code" [country]="country.name" [placeholder]="true" href="/sign-up"></ge-card>
        </div>
        <div *ngFor="let job of jobsintown | async;" class="slide ion-text-left">
          <job-card [id]="job.id" [image]="false" [highlights]="false" href="/jobs/detail/{{job.slug}}"></job-card>
        </div>
      </div>
    </div>
  </div>
  <div class="row volunteers" id="volunteers" *ngIf="showvols">
    <div class="col ion-no-padding slide-scroll">
      <div class="slide-wrapper">
        <div *ngIf="placeholder" class="slide ion-text-left">
          <ge-card service="volunteers" skill="{{skill}}" [code]="country.code" [country]="country.name" [placeholder]="true" href="/sign-up"></ge-card>
        </div>
        <div *ngFor="let vol of volsintown | async;" class="slide ion-text-left">
          <vol-card [id]="vol.id" [image]="false" [highlights]="false" href="/volunteers/detail/{{vol.slug}}"></vol-card>
        </div>
      </div>
    </div>
  </div>
  <div class="row promote" id="promote" *ngIf="showads">
    <div class="col ion-no-padding slide-scroll" *ngIf="view=='list'">
      <div class="slide-wrapper">
        <div *ngIf="placeholder" class="slide ion-text-left">
          <ge-card service="promote" skill="{{skill}}" [code]="country.code" [country]="country.name" [placeholder]="true" href="/sign-up"></ge-card>
        </div>
        <div *ngFor="let ad of adsintown | async;" class="slide ion-text-left">
          <ad-card [id]="ad.id" [image]="false" [highlights]="false" href="/promote/detail/{{ad.slug}}"></ad-card>
        </div>
      </div>
    </div>
    <div class="col slide-grid ion-text-center" *ngIf="view=='grid'">
      <div *ngFor="let ad of adsintown | async;" class="slide ion-text-left">
        <ad-card [id]="ad.id" [image]="false" [highlights]="false" href="/promote/detail/{{ad.slug}}"></ad-card>
      </div>
    </div>
  </div>
</div>